import * as types from "./actionTypes"

const initialState = {
    switchInstructionPatterns: {},
    isSwitchRequestCreated: false,
    isSwitchRequestCreationFailed: false,
    switchRequests: [],
    firstSwitchRequests: {},
    patterns: [],
}

export default function switchRequestsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SWITCH_INSTRUCTION_PATTERNS: {
            const patterns = action.payload?.Patterns?.reduce(
                (result, pattern) => {
                    result[pattern.PatternId] = pattern
                    return result
                },
                {}
            )
            return {
                ...state,
                switchInstructionPatterns: patterns,
            }
        }
        case types.FETCH_SWITCH_INSTRUCTION_PATTERNS: {
            return {
                ...state,
                switchInstructionPatterns: {},
            }
        }
        case types.CREATE_SWITCH_INSTRUCTION: {
            return {
                ...state,
                isSwitchRequestCreated: false,
                isSwitchRequestCreationFailed: false,
            }
        }
        case types.CREATE_SWITCH_INSTRUCTION_SUCCESS: {
            return {
                ...state,
                isSwitchRequestCreated: true,
            }
        }
        case types.CREATE_SWITCH_INSTRUCTION_FAILURE: {
            return {
                ...state,
                isSwitchRequestCreationFailed: true,
            }
        }

        case types.SWITCH_REQUESTS_DATA_SUCCESS:
            return {
                ...state,
                switchRequests: action.payload.SwitchInstructionDetails
                    ? action.payload.SwitchInstructionDetails.sort((a, b) => {
                          return new Date(a.WantDate) - new Date(b.WantDate)
                      })
                    : [],
                firstSwitchRequests: action.payload.SwitchInstructionDetails
                    ? action.payload.SwitchInstructionDetails.sort((a, b) => {
                          return new Date(a.WantDate) - new Date(b.WantDate)
                      })[0]
                    : {},
            }
        default:
            return state
    }
}
